"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M14.653 2.358a10 10 0 0 0-5.221-.022c-1.1.272-2.12.74-3.064 1.4A10 10 0 0 0 4.809 5.05V3.736c0-.337-.126-.631-.378-.882a1.208 1.208 0 0 0-.882-.377c-.337 0-.633.125-.886.378a1.214 1.214 0 0 0-.379.886v4.447a1.358 1.358 0 0 0 1.379 1.377l4.451-.004c.337 0 .632-.127.885-.38s.38-.548.38-.885c0-.337-.127-.632-.38-.885a1.214 1.214 0 0 0-.885-.38l-1.342.005h-.673a7.709 7.709 0 0 1 2.447-1.933l.322-.152a7.714 7.714 0 0 1 5.178-.388l.342.103a7.712 7.712 0 0 1 4.107 3.176l.186.305a7.714 7.714 0 0 1 .862 5.46l-.083.347a7.714 7.714 0 0 1-2.929 4.287l-.293.202a7.714 7.714 0 0 1-5.046 1.227l-.354-.046A7.714 7.714 0 0 1 4.288 12 1.144 1.144 0 0 0 2 12a10.003 10.003 0 0 0 8.493 9.887l.459.059a10.003 10.003 0 0 0 6.543-1.59l.38-.263a10.004 10.004 0 0 0 3.8-5.56l.106-.45a10.002 10.002 0 0 0-1.118-7.078l-.24-.395a10.001 10.001 0 0 0-5.327-4.119l-.443-.132Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};